










import { Vue, Component } from 'vue-property-decorator';
import Alertas from '@/pantallas/Alertas/Alertas.vue';

@Component({
  components: { Alertas },
})
export default class AlertasPantalla extends Vue {}
